import axios from "axios";
axios.defaults.withCredentials = true;

export const commonInsertWithPost = async(path, data, ) =>{
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/${path}`, data);
        return response.data
    } catch (error) {
        return error?.response?.data;
    }
}